<template>
  <div class="parent-checklist-page">
    <header class="parent-checklist-header">
      <h1 class="title">学習用デバイスの準備チェックリスト</h1>
      <p class="lead">
        こちらは<strong>保護者さま用のページ</strong>です。<br />
        この端末で手順を確認しながら、お子さまが学習に使うスマホ・タブレットの設定を進めてください。
      </p>
    </header>

    <main class="parent-checklist-main">
      <section class="checklist-section">
        <h2>Step 1. ドメイン・サイトへのアクセス許可</h2>
        <ul>
          <li>学習端末のブラウザから <code>https://app.otoeigo.com</code> にアクセスできるか確認する。</li>
          <li>ファミリーリンクやフィルタリングサービスでブロックされている場合は、許可リストに追加する。</li>
        </ul>
      </section>

      <section class="checklist-section">
        <h2>Step 2. マイクの利用許可</h2>
        <ul>
          <li>学習端末でオトエイゴを開き、マイクアクセスの確認ダイアログが表示されたら「許可」を選ぶ。</li>
          <li>すでに「ブロック」してしまった場合は、ブラウザの設定画面からマイク許可をオンにする。</li>
        </ul>
      </section>

      <section class="checklist-section">
        <h2>Step 3. サイトデータ（ローカル保存）の許可</h2>
        <ul>
          <li>学習端末で Cookie / サイトデータの保存が禁止されていないか確認する。</li>
          <li>Google ファミリーリンクをお使いの場合は、「サイトデータを許可する」設定になっているか確認する。</li>
        </ul>
      </section>

      <section class="checklist-section">
        <h2>Step 4. Day0 チュートリアルの実施</h2>
        <ul>
          <li>学習端末でログインし、Day0（練習前チュートリアル）に進む。</li>
          <li>録音テストで「練習録音」「課題録音」が問題なく完了するか確認する。</li>
        </ul>
      </section>

      <p class="note">
        ※ このページは今後、OS／ブラウザごとの具体的な画面付き手順を追加する予定です。
      </p>
    </main>
  </div>
</template>

<script setup>
</script>

<style scoped>
.parent-checklist-page {
  max-width: 720px;
  margin: 0 auto;
  padding: 2rem 1.5rem 3rem;
}

.parent-checklist-header {
  margin-bottom: 1.5rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.75rem 0;
  color: #111827;
}

.lead {
  font-size: 0.95rem;
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
}

.parent-checklist-main {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 1rem;
}

.checklist-section {
  padding: 1rem 1.25rem;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.checklist-section h2 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #111827;
}

.checklist-section ul {
  margin: 0;
  padding-left: 1.2rem;
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.6;
}

.note {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: #6b7280;
}
</style>

